import { replace } from 'react-router';

import { getSession } from '@/auth/AuthSession';
import { isAuthenticated } from '@/auth/AuthUtils';
import { routeAfterAuthenticated } from '@/auth/constants/authSettings';

/**
 * Route loader for the sign-in entry points. A signed-in user who opens the app on `/` is sent on
 * before the page renders; redirecting from the page itself shows the sign-in form until the
 * dashboard's chunks have loaded. It replaces the history entry, so Back skips the sign-in page.
 */
export function redirectSignedInUser(): Response | null {
	if (!isAuthenticated()) {
		return null;
	}

	const session = getSession();
	return replace(session?.isLoggedIn && !session.userGroupId ? '/no-space' : routeAfterAuthenticated);
}
